module.exports = __webpack_public_path__ + "static/media/tela3.a8640886.png";